import {
  AutopilotTaskDto,
  TaskCategoryTaskType,
} from '@urbanx/agx.activities.client'
import { TaskUpdatedNotification } from 'types/pushNotifications'
import { splitPascalCase } from 'utils/stringUtils'

export interface TaskIdentity {
  campaignId?: string
  contractId?: string
  taskType?: TaskCategoryTaskType
}

type TaskIdentitySource = Pick<
  AutopilotTaskDto,
  'campaignId' | 'contractId' | 'category'
>

export const getTaskIdentity = (
  task?: TaskIdentitySource
): TaskIdentity => ({
  campaignId: task?.campaignId,
  contractId: task?.contractId ?? undefined,
  taskType: task?.category?.taskType,
})

const taskTypeLabels: Partial<Record<TaskCategoryTaskType, string>> = {
  [TaskCategoryTaskType.VpaSpreadsheet]: 'VPA Spreadsheet',
}

export const getTaskTypeLabel = (taskType?: TaskCategoryTaskType) =>
  taskType ? taskTypeLabels[taskType] ?? splitPascalCase(taskType) : ''

export const getTaskUpdateIdentity = (
  taskUpdate?: TaskUpdatedNotification
): TaskIdentity => getTaskIdentity(taskUpdate?.task)

export const areTaskIdentitiesEqual = (
  left?: TaskIdentity,
  right?: TaskIdentity
): boolean =>
  left?.campaignId === right?.campaignId &&
  left?.contractId === right?.contractId &&
  left?.taskType === right?.taskType

export const isSameTask = (
  task: TaskIdentitySource,
  candidate: TaskIdentitySource
) => areTaskIdentitiesEqual(getTaskIdentity(task), getTaskIdentity(candidate))

export const doesTaskMatchUpdate = (
  task: TaskIdentitySource,
  taskUpdate: TaskUpdatedNotification
) =>
  areTaskIdentitiesEqual(getTaskIdentity(task), getTaskUpdateIdentity(taskUpdate))
